import connect from "react-redux/es/connect/connect";
import {
    addProduct,
    checkoutInventory,
    deleteProduct, emptyInventory,
    updateProduct, updateProductFormats,
    updateProductLocationAmount
} from "../../../../state/modules/inventory";

import React from "react";
import BarcodeScanner from "../../barcode-scanner";
import Grid from "../../grid";
import InventoryListItem from "../inventory-list-item";
import Window from "../../window";
import {handleTokenErrors} from "../../../../state/modules/errors";
import {API_HOST, API_ROOT, http} from "../../../../util/http";
import ui from "../../../../util/ui";

class InventoryUpdateStock extends React.Component {
  static defaultProps = {
    isScanning: false,
    activeLocation: null,
    toggleLoading: () => null,
    toggleScanning: () => null,
    openPopup: () => null,
  };

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <Grid cols={'1fr auto'}>
                <Window modifiers={['frame']}>
                    <BarcodeScanner
                        showErrors={false}
                        defaultValues={this.props.products}
                        isScanning={this.props.isScanning}
                        onReleaseFound={release => {
                            this.props.addProduct(release, this.props.activeLocation);
                        }}
                        onMultipleReleasesFound={(releases, barcode) => {
                            releases.forEach(release => {
                                this.props.addProduct(release, this.props.activeLocation);
                            });
                        }}
                        onReleaseNotFound={barcode => {
                            this.props.toggleLoading();
                            this.props.toggleScanning();
                            
                            http
                                .get(API_HOST + API_ROOT + 'discogs/barcode/' + barcode, true)
                                .then(response => {
                                    let discogsRelease = response.result;
                                    this.props.addProduct(discogsRelease);
                                    this.props.toggleLoading();
                                    
                                    this.props.openPopup(
                                        'discogsReleaseCreate',
                                        discogsRelease,
                                        discogsRelease.barcode
                                    );
                                })
                                .catch(error => {
                                    this.toggleLoading();
                                    
                                    if (error.message === 'release_not_found') {
                                        ui.notify('Discogs release not found', 'error');
                                    }
                                })
                                .catch(error => handleTokenErrors(error));
                        }}
                    />
                    <div className="list">
                        <div className="list__items">
                            {Object.values(this.props.products).map((product, key) => (
                                <InventoryListItem
                                    model={product}
                                    key={key}
                                    onEdit={product =>
                                        this.props.openPopup('productStockUpdate', product)
                                    }
                                    onDelete={product =>
                                        this.props.deleteProduct(product)
                                    }
                                />
                            ))}
                        </div>
                    </div>
                </Window>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    products: state.inventory.products,
});

const mapDispatchToProps = {
    addProduct: addProduct,
    updateProductLocationAmount: updateProductLocationAmount,
    updateProductFormats: updateProductFormats,
    updateProduct: updateProduct,
    deleteProduct: deleteProduct,
    checkoutInventory: checkoutInventory,
    emptyInventory: emptyInventory,
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryUpdateStock);
